import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';

import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasPhData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PhActions } from '../phActions';
import { IAppState } from '../appState';
import { buildTaasPhDataForStrecke } from './transformer/phData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasPhData>;

export function* streckenTarifierungPH(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    PhActions.PREISE_REQUESTED,
    PhActions.SELBSTBETEILIGUNG_CHANGED,
    PhActions.ANZAHL_WOHNUNGEN_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_PH,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_PH,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.PH,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_PH,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_PH,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_PH,
    },
    buildTaasPhDataForStrecke,
    undefined,
    createHashedRelevantRiskdataPH,
  );

  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.PH));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_PH,
    safeSaga(streckenTarifierer.handleError, App.PH),
  );

  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.PH));
}

export function createHashedRelevantRiskdataPH(taasData: TaasPhData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.anzWohnungen;

  return createHashedTaasData(relevantData);
}
